import { Component, OnInit } from "@angular/core";
import { RouterLink, RouterOutlet } from "@angular/router";
import { ApplicationsTableComponent } from "../common/components/applications-table/applications-table.component";
import { WelcomeComponent } from "./welcome/welcome.component";
import { MatDialog } from "@angular/material/dialog";
import { ResetPassDialogComponent } from "../authentication/reset-pass-dialog/reset-pass-dialog.component";

@Component({
  selector: "app-admin-dashboard",
  standalone: true,
  imports: [
    WelcomeComponent,
    RouterOutlet,
    RouterLink,
    ApplicationsTableComponent,
  ],
  templateUrl: "./admin-dashboard.component.html",
  styleUrl: "./admin-dashboard.component.scss",
})
export class AdminDashboardComponent implements OnInit {
  constructor(private dialog: MatDialog) {

  }
  ngOnInit(): void {
    const storedUser = sessionStorage.getItem('currentUser')
    const user = storedUser ? JSON.parse(storedUser) : null
    if (user && user.shouldRenewPassword) {
      this.onPassChange()
    }
  }
  private onPassChange() {
    const dialogConfig = this.dialog.open(ResetPassDialogComponent, {
      minWidth: "650px",
      width: "800px",
      maxHeight: "90vh",
      disableClose: true,
    });
    dialogConfig.afterClosed().subscribe((results) => {
    });
  }
}
